// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__aCPpn","requiredAsterisk":"Info_requiredAsterisk__3NDHO"};